module.exports = __webpack_public_path__ + "static/media/completed-green.cf84fd70.svg";